import type { SVGProps } from "react";
export interface ChatFaceIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ChatFaceIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ChatFaceIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.133 4.133c4.344-4.345 11.39-4.345 15.734 0s4.344 11.39 0 15.734c-3.477 3.477-8.68 4.17-12.847 2.084l-3.17.762c-1.543.37-2.933-1.02-2.563-2.562l.76-3.173C-.037 12.812.657 7.609 4.133 4.133m14.143 1.592a8.875 8.875 0 0 0-12.55 0 8.88 8.88 0 0 0-1.5 10.562c.136.245.175.534.109.807l-.813 3.382 3.385-.811.207-.03c.207-.01.415.038.599.14a8.875 8.875 0 0 0 10.563-14.05"
      />
      <path
        fill={color}
        d="M15.175 14.237a1.125 1.125 0 0 1 1.724 1.44l-.217.27a6.11 6.11 0 0 1-4.681 2.178 6.11 6.11 0 0 1-4.684-2.177l-.216-.271-.065-.097a1.126 1.126 0 0 1 1.79-1.343l.074.088.137.173a3.87 3.87 0 0 0 2.964 1.377 3.87 3.87 0 0 0 3.1-1.55zM15 9.127a.62.62 0 0 0-.126.373l.013.126a.6.6 0 0 0 .113.246zm.999.745a.6.6 0 0 0 .112-.246l.014-.126-.014-.126A.6.6 0 0 0 16 9.127zm-6.888-.498A.6.6 0 0 0 9 9.129v.741a.6.6 0 0 0 .11-.244l.014-.126zM8 9.129a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm2.126.37a1.625 1.625 0 0 1-3.242.167L6.875 9.5l.009-.166A1.625 1.625 0 0 1 8.5 7.875l.167.009A1.626 1.626 0 0 1 10.126 9.5Zm6.999 0a1.625 1.625 0 0 1-3.242.168l-.007-.167.007-.166a1.626 1.626 0 0 1 3.242.166Z"
      />
    </svg>
  );
}
